import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['fieldset', 'section'];

  disable() {
    setTimeout(() => {
      this.fieldsetTargets.forEach((fieldset) => {
        fieldset.disabled = true;
      });
    }, 1);
  }

  switchType(event) {
    this.sectionTargets.forEach((section) => {
      const visible = section.dataset.activityType === event.detail.newValue;
      section.hidden = !visible;
      section.disabled = !visible;
    });
  }
}
